module.exports = __webpack_public_path__ + "static/img/icon_search.023d980d.png";